import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Layout from "./container/layoutMain/main";
import Authentication from "../src/pages/authentication/indexSeverTest";

import HomePage from "./pages/home";
import HistoryPage from "./pages/history";
import ControllerPage from "./pages/controller";
import ScenePage from "./pages/scene";
import SchdulePage from "./pages/schedule";
import AddSchdulePage from "./pages/schedule_add";
import EditSchdulePage from "./pages/schedule_edit";
import SceneEditPage from "./pages/scene_edit";
import SceneAddPage from "./pages/scene_add_name";
import SceneRoomsPage from "./pages/scene_add_rooms";

import {
  getUserlogin,
  setStateChangedStored,
} from "./stored/mydata";

const themeConfig = {
  token: {
    colorPrimary: "rgba(62, 168, 184, 1)",
  },
  components: {
    Tabs: {
      inkBarColor: "rgba(62, 168, 184, 1)",
      itemSelectedColor: "rgba(62, 168, 184, 1)",
    },
    Slider: {
      railSize: 8,
      handleActiveColor: "rgba(62, 168, 184, 1)",
    },
  },
};

const PrivateRoute = ({ children }) => {
  const userlogin = useSelector(getUserlogin);

  return userlogin ? children : <Navigate to="/" replace />;
};

function Root() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userlogin = useSelector(getUserlogin);
  const uuid = localStorage.getItem("Obtuuid");

  useEffect(() => {
    const eventStateChanged = localStorage.getItem("Obtstate");

    if (eventStateChanged) {
      dispatch(setStateChangedStored(eventStateChanged));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!uuid && !userlogin) {
      navigate("/", { replace: true });
    }
  }, [uuid, userlogin, navigate]);

  return (
    <ConfigProvider prefixCls="ant" theme={themeConfig}>
      <Routes>
        {/* Login */}
        <Route path="/" element={<Authentication />} />

        {/* Protected Routes */}
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/home" element={<HomePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/controller" element={<ControllerPage />} />
          <Route path="/scene" element={<ScenePage />} />
          <Route path="/schdule" element={<SchdulePage />} />

          <Route path="/sceneadd" element={<SceneAddPage />} />
          <Route path="/sceneedit/:roomid" element={<SceneEditPage />} />
          <Route path="/scenerooms/:sceneid" element={<SceneRoomsPage />} />

          <Route path="/addschdule" element={<AddSchdulePage />} />
          <Route
            path="/editschdule/:schduleid"
            element={<EditSchdulePage />}
          />
        </Route>

        {/* Not Found */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfigProvider>
  );
}

export default Root;